export default "__VITE_ASSET__5bb43362__"